export default {
  IN_FRAME: 1,
  EXPANDED_VIEW: 2,
};



// WEBPACK FOOTER //
// ./src/widget/player-widget/constants/default-settings/compact-play-type.js